export const logos = [
    {
        name: "New Year",
        startDate: "2024-12-31 00:00:00",
        endDate: "2025-01-01 00:00:00",
        lottieFile: "/assets/Lottie/NewYear2025/purple.lottie",
        color: 'purple'
    },
    {
        name: "New Year",
        startDate: "2024-12-31 00:00:00",
        endDate: "2025-01-01 00:00:00",
        lottieFile: "/assets/Lottie/NewYear2025/white.lottie",
        color: 'white'
    },
];
